module.exports = __webpack_public_path__ + "media/images/animations/overhight_load/4-5b12ff6112ecdcfc7fc4d37dc0ee4f59.png";